/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  paymentStatusHeader: 'paymentStatusHeader',
  openPayment: 'openPayment',
  paidAmount: 'paidAmount',
  paymentType: 'paymentType',
  paymentDate: 'paymentDate',
  dueDate: 'dueDate',
  bookingNumber: 'bookingNumber',
  bookingState: 'bookingState',
  totalAmount: 'totalAmount',
  paymentStatus: 'paymentStatus',
  arrivalDate: 'arrivalDate',
  bookingDate: 'bookingDate',
  departureDate: 'departureDate',
  traveler: 'traveler',
  bookedService: 'bookedService',
  notes: 'notes',
  noNotes: 'noNotes',
  cancel: 'cancel',
  bookingStateValue: {
    OPEN: 'bookingStateValue.OPEN',
    PENDING: 'bookingStateValue.PENDING',
    BOOKED: 'bookingStateValue.BOOKED',
    CANCELLED: 'bookingStateValue.CANCELLED',
    REQUEST: 'bookingStateValue.REQUEST',
    OPTION: 'bookingStateValue.OPTION',
    QUOTE: 'bookingStateValue.QUOTE'
  },
  paymentOptionValue: {
    CREDITCARD: 'paymentOptionValue.CREDITCARD',
    CREDITLIMIT: 'paymentOptionValue.CREDITLIMIT',
    INVOICE: 'paymentOptionValue.INVOICE',
    UNDEFINED: 'paymentOptionValue.UNDEFINED',
    BANKTRANSFER: 'paymentOptionValue.BANKTRANSFER',
    VOUCHER: 'paymentOptionValue.VOUCHER',
    CASH: 'paymentOptionValue.CASH',
    DIRECTDEBIT: 'paymentOptionValue.DIRECTDEBIT',
    A: 'paymentOptionValue.A',
    M: 'paymentOptionValue.M',
    V: 'paymentOptionValue.V',
    DebitDE: 'paymentOptionValue.DebitDE',
    Paypal: 'paymentOptionValue.Paypal'
  },
  paymentStateValue: {
    UNDEFINED: 'paymentStateValue.UNDEFINED',
    OPEN: 'paymentStateValue.OPEN',
    PAID: 'paymentStateValue.PAID',
    AUTHORIZED: 'paymentStateValue.AUTHORIZED'
  }
}; export default Keys;